var _excluded = ["className", "children", "oversized", "scrolling", "tall", "vertical"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import AButton from "../AButton";
import AIcon from "../AIcon";
import ATabContext from "./ATabContext";
import { getRoundedBoundedClientRect } from "../../utils/helpers";
import { useCombinedRefs } from "../../utils/hooks";
import "./ATabs.scss";
var ATabGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? [] : _ref$children,
    oversized = _ref.oversized,
    scrolling = _ref.scrolling,
    tall = _ref.tall,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    tabChanged = _useState2[0],
    setTabChanged = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    translateX = _useState4[0],
    setTranslateX = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showScrolling = _useState6[0],
    setShowScrolling = _useState6[1];
  var tabGroupRef = useRef(null);
  var combinedRef = useCombinedRefs(ref, tabGroupRef);
  useEffect(function () {
    if (scrolling && combinedRef && combinedRef.current) {
      var wrapper = combinedRef.current.querySelector(".a-tab-group__tab-wrapper");
      var content = combinedRef.current.querySelector(".a-tab-group__tab-content");
      setShowScrolling(content.scrollWidth - wrapper.clientWidth + 1 > 0);
      var _maxTranslateValue = content.scrollWidth - wrapper.clientWidth + 1;
      setTranslateX(function (current) {
        return -Math.max(Math.min(current, _maxTranslateValue), 0);
      });
    }
  }, [scrolling, combinedRef, children.length]);
  var className = "a-tab-group";
  if (oversized) {
    className += " a-tab-group--size-oversized";
    if (vertical) {
      className += " a-tab-group--size-oversized--vertical";
    }
  } else if (tall) {
    className += " a-tab-group--size-tall";
  }
  if (scrolling) {
    className += " a-tab-group--scrolling";
  }
  var tabContentClassName = "a-tab-group__tab-content";
  if (vertical) {
    tabContentClassName += " a-tab-group__tab-content--vertical";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var maxTranslateValue = -1;
  if (scrolling && combinedRef && combinedRef.current) {
    var wrapper = combinedRef.current.querySelector(".a-tab-group__tab-wrapper");
    var content = combinedRef.current.querySelector(".a-tab-group__tab-content");
    maxTranslateValue = content.scrollWidth - wrapper.clientWidth + 1;
  }
  var tabContext = {
    tabChanged: tabChanged,
    setTabChanged: setTabChanged,
    scrollToMe: function scrollToMe(meRef) {
      if (!scrolling || !combinedRef.current) return;
      var tabWrapper = combinedRef.current.querySelector(".a-tab-group__tab-wrapper");
      var contentWrapper = combinedRef.current.querySelector(".a-tab-group__tab-content");
      var maxTranslateValue2 = contentWrapper.scrollWidth - tabWrapper.clientWidth + 1;
      tabWrapper.scrollLeft = 0;
      contentWrapper.scrollLeft = 0;
      var selectedTabBounds = getRoundedBoundedClientRect(meRef.current);
      var tabWrapperBounds = getRoundedBoundedClientRect(tabWrapper);
      var translateValue = selectedTabBounds.left - tabWrapperBounds.left - tabWrapperBounds.width / 2 + selectedTabBounds.width / 2;
      setTranslateX(function (current) {
        return -Math.max(Math.min(translateValue - 1 - current, maxTranslateValue2), 0);
      });
    },
    vertical: vertical
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    role: "tablist",
    ref: combinedRef,
    className: className
  }), showScrolling && /*#__PURE__*/React.createElement(AButton, {
    tertiaryAlt: true,
    icon: true,
    className: "a-tab-group__scroll-left",
    disabled: translateX >= 0,
    onClick: function onClick() {
      var wrapperBounds = getRoundedBoundedClientRect(combinedRef.current.querySelector(".a-tab-group__tab-wrapper"));
      var tabs = _toConsumableArray(combinedRef.current.querySelectorAll(".a-tab-group__tab")).map(getRoundedBoundedClientRect);
      var translateValue = Math.max.apply(Math, [wrapperBounds.left + translateX].concat(_toConsumableArray(tabs.filter(function (x) {
        return x.left < wrapperBounds.left;
      }).map(function (x) {
        return x.right;
      })))) - wrapperBounds.width - wrapperBounds.left - translateX + 1;
      var finalTranslateValue = Math.max(translateValue, 0);
      setTranslateX(-finalTranslateValue);
    }
  }, /*#__PURE__*/React.createElement(AIcon, null, "chevron-left")), /*#__PURE__*/React.createElement("div", {
    className: "a-tab-group__tab-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: tabContentClassName,
    style: {
      transform: "translateX(".concat(translateX, "px)")
    }
  }, /*#__PURE__*/React.createElement(ATabContext.Provider, {
    value: tabContext
  }, children))), showScrolling && /*#__PURE__*/React.createElement(AButton, {
    tertiaryAlt: true,
    icon: true,
    className: "a-tab-group__scroll-right",
    disabled: translateX <= -maxTranslateValue,
    onClick: function onClick() {
      var wrapperBounds = getRoundedBoundedClientRect(combinedRef.current.querySelector(".a-tab-group__tab-wrapper"));
      var tabs = _toConsumableArray(combinedRef.current.querySelectorAll(".a-tab-group__tab")).map(getRoundedBoundedClientRect);
      var translateValue = Math.min.apply(Math, _toConsumableArray(tabs.filter(function (x) {
        return x.right > wrapperBounds.right;
      }).map(function (x) {
        return x.left;
      }))) - wrapperBounds.left - translateX;
      var finalTranslateValue = Math.min(translateValue - 1, maxTranslateValue);
      setTranslateX(-finalTranslateValue);
    }
  }, /*#__PURE__*/React.createElement(AIcon, null, "chevron-right")));
});
ATabGroup.propTypes = {
  /**
   * Toggle the oversized style variant.
   */
  oversized: PropTypes.bool,
  /**
   * Toggles scrolling behavior.
   */
  scrolling: PropTypes.bool,
  /**
   * Toggle the tall style variant.
   */
  tall: PropTypes.bool
};
ATabGroup.displayName = "ATabGroup";
export default ATabGroup;